export default __webpack_public_path__ + "static/media/sample.4764e15d.png";